import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ICombineReducerType } from '../../redux/reducers';
import { getFilteredCarsFooter } from '../../redux/actions/filteredCarsFooterActions';
import { Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'phosphor-react';
import { useTranslation } from 'react-i18next';

const FilteredCarModelsFooter = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const filterCarsFooterData = useSelector(
        (state: ICombineReducerType) => state.filterCarsFooter
    );
    useEffect(() => {
        getFilteredCarsFooter(dispatch);
    }, []);

    return (
        <>
            {filterCarsFooterData?.models.length && (
                <div className="filterCarsFooter padding">
                    <Row gutter={[16, 16]}>
                        {filterCarsFooterData?.models.map((item) => (
                            <Col xs={12} sm={12} md={8} lg={6} key={item?._id}>
                                <p
                                    onClick={() => {
                                        navigate({
                                            pathname: t('/buy-cars', {
                                                ns: 'routes'
                                            }),
                                            search: `?brand=${item?.brand?.slug}&model=${item?.slug}&isNewCar=false`
                                        });
                                    }}
                                >
                                    <ArrowUpRight size={16} /> {t('used')}{' '}
                                    {item?.brand?.brand} {item?.model}
                                </p>
                            </Col>
                        ))}
                    </Row>
                </div>
            )}
        </>
    );
};

export default FilteredCarModelsFooter;
